import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/LiveAnnouncer.tsx");
